import { TipoCompensacaoManual } from '@acme/core'
import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useCompensacaoManualOutletContext } from '@/pages/CompensacaoManual'
import {
    compensacaoManual,
    CreateCompensacaoManual,
    createCompensacaoManualSchema,
} from '@/service/api'
import { useStore } from '@/store'
import { toast } from 'sonner'
import FormCompensacaoManual from '../forms/FormCompensacaoManual'

export default function AdicionarCompensacaoManualModal() {
    const { competencia } = useCompensacaoManualOutletContext()
    const { mutateAsync, isLoading } = compensacaoManual.mutations.useCreate({
        invalidateQuery: true,
    })
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    function handleSubmit(data: CreateCompensacaoManual) {
        if (funcionarioId < 1) {
            toast.error('Selecione um funcionário')
            return
        }

        if (empresaId < 1) {
            toast.error('Selecione uma empresa')
            return
        }

        const destinos =
            data.tipo === TipoCompensacaoManual.MESMO_DIA
                ? [{ data: data.data }]
                : data.destinos

        mutateAsync(
            {
                ...data,
                destinos,
                empresaId,
                funcionarioId,
                competencia,
            },
            {
                onSuccess: () => {
                    toast.success('Compensação manual criada com sucesso!')
                },
                onError: err => {
                    toast.error(
                        err.message || 'Erro ao criar compensação manual',
                    )
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            width="45rem"
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createCompensacaoManualSchema.omit({ competencia: true })}
            defaultValues={{
                tipo: TipoCompensacaoManual.COMPENSAR,
                destinos: [],
            }}
            open={hasPermission(['create', 'CompensaçãoManual'])}
        >
            <Dialog.Title>Nova compensação manual</Dialog.Title>
            <Dialog.Content dividers>
                <FormCompensacaoManual />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
